import React from 'react'
import { motion } from 'framer-motion'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
export default function LoansLayout() {
    const { pathname, state } = useLocation()
    const { id } = useParams()
    const navigate = useNavigate()
    const isAddButton = pathname.includes('requested-loans')
    return (
        <div className="sm:w-full md:px-[35%] relative md:bg-bg-md-screen">
            <div className=" h-full bg-main-bg">
                <div className=" min-h-screen flex flex-col relative">
                    <motion.div
                        key={pathname}
                        initial={{ opacity: 0, x: '100%' }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: '-100%' }}
                        transition={{ duration: 0.2 }}
                        className=" grow"
                    >
                        <div className="">
                            <Outlet />
                        </div>
                    </motion.div>
                    {isAddButton && (
                        <div className=" fixed bottom-6 right-4 z-30 md:right-[37%]">
                            <button
                                type="button"
                                className=" flex items-center gap-1.5 rounded-full bg-green-1 py-3 pl-5 pr-4 text-sm font-bold text-white shadow-[0_6px_20px_-6px_rgba(0,0,0,0.35)] active:scale-[0.98]"
                                onClick={() =>
                                    // The wizard reads the caller's own
                                    // membership from `?poolship=` rather than
                                    // router state: this link is also the one
                                    // people bookmark and reload, and router
                                    // state does not survive that — which is
                                    // how the old form ended up asking for a
                                    // bank card it could not look up.
                                    navigate(
                                        `/loans/request/${id}?poolship=${
                                            state?.poolShipId ?? ''
                                        }`,
                                        {
                                            state: {
                                                poolShipId: state?.poolShipId,
                                            },
                                        }
                                    )
                                }
                            >
                                <span
                                    aria-hidden
                                    className=" text-lg leading-none"
                                >
                                    +
                                </span>
                                ثبت درخواست وام
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
